import React, { Fragment } from "react";
import "./breadCrumb.scss";

const BreadCrumb = ({
  type,
  community,
  province,
  onClick
}) => {
  const onClickHandler = item => {
    if (onClick) {
      onClick(item);
    }
  };

  return React.createElement(Fragment, null, React.createElement("div", {
    className: "breadCrumb"
  }, React.createElement("ul", {
    className: "breadCrumb_content"
  }, type && React.createElement("li", {
    className: "breadCrumb_item_container breadCrumb_item_type"
  }, React.createElement("div", {
    className: "breadCrumb_item"
  }, React.createElement("span", {
    className: "breadCrumb_item_content"
  }, React.createElement("span", {
    className: "truncate",
    onClick: () => onClickHandler()
  }, type)))), community && community.typePlace !== "COUNTRY" && React.createElement("li", {
    className: "breadCrumb_item_container breadCrumb_item_community",
    onClick: () => onClickHandler(community)
  }, React.createElement("div", {
    className: "breadCrumb_item"
  }, React.createElement("span", {
    className: "breadCrumb_item_content"
  }, React.createElement("span", {
    className: "truncate"
  }, community.name)))), province && React.createElement("li", {
    className: "breadCrumb_item_container breadCrumb_item_province",
    onClick: () => onClickHandler(province)
  }, React.createElement("div", {
    className: "breadCrumb_item"
  }, React.createElement("span", {
    className: "breadCrumb_item_content"
  }, React.createElement("span", {
    className: "truncate"
  }, province.name)))))));
};

export default BreadCrumb;